export default "__VITE_ASSET__fs06$Hx4__"